/**
 * How it works — three numbered cards on a row with fire-accent.
 *
 * Each step is a self-contained card; the divider between them is a
 * thin dashed line (only on md+). On mobile they stack.
 */
import { useTranslation } from 'react-i18next'
import { UserPlus, KeyRound, LineChart } from 'lucide-react'
import { Header } from './Features'

const STEPS = [
  { key: 'signup',  icon: UserPlus  },
  { key: 'connect', icon: KeyRound  },
  { key: 'watch',   icon: LineChart },
] as const

export function HowItWorks() {
  const { t } = useTranslation('landing')
  return (
    <section
      id="how-it-works"
      className="px-6 py-20 md:py-28 border-t border-line scroll-mt-16"
    >
      <div className="max-w-6xl mx-auto">
        <Header
          label={t('how.section_label')}
          title={t('how.title')}
        />

        <div className="mt-12 grid md:grid-cols-3 gap-6 md:gap-8 relative">
          {/* Decorative connector line on desktop only */}
          <div
            aria-hidden
            className="hidden md:block absolute left-0 right-0 top-12 h-px"
            style={{
              backgroundImage:
                'linear-gradient(90deg, transparent 0, var(--line) 50%, transparent 100%)',
            }}
          />

          {STEPS.map(({ key, icon: Icon }, idx) => (
            <article
              key={key}
              className="relative bg-surface border border-line rounded-md p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 grid place-items-center bg-fire-faint rounded">
                  <Icon size={18} className="text-fire" />
                </div>
                <div className="font-mono text-xs text-textFaint">
                  STEP {String(idx + 1).padStart(2, '0')}
                </div>
              </div>
              <h3 className="text-lg font-semibold tracking-tight">
                {t(`how.steps.${key}.title`)}
              </h3>
              <p className="mt-2 text-sm text-textDim leading-relaxed">
                {t(`how.steps.${key}.body`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
